/**
 * Понятные сообщения об ошибках бронирования / расписания (WA-09).
 * Использует httpStatus с handleError (api.js) и эвристики по тексту ответа.
 */

function getHttpStatus(error) {
  if (!error) return null;
  if (typeof error.httpStatus === 'number') return error.httpStatus;
  if (error.response && typeof error.response.status === 'number') return error.response.status;
  return null;
}

/**
 * @param {Error & { httpStatus?: number, response?: Response }} error
 * @returns {string}
 */
export function formatBookingErrorForUser(error) {
  const status = getHttpStatus(error);
  const raw = error && error.message ? String(error.message).trim() : '';

  if (status === 401) {
    return raw ? `${raw}\nОбновите страницу и войдите снова.` : 'Сессия истекла. Обновите страницу и войдите заново.';
  }

  if (status === 409) {
    const next =
      'Выберите другой интервал или устраните пересечение: другое бронирование, блокировка или занятие секции на этой площадке.';
    return raw ? `Конфликт расписания: ${raw}\n${next}` : `Конфликт расписания: выбранное время недоступно.\n${next}`;
  }

  if (status === 400) {
    if (/абонемент|явк|записан|свободных мест|пользователь не найден|укажите userId|занятие уже завершено|отменённ/i.test(raw)) {
      return raw;
    }
    if (/секци|персональн|section_occurrence|personal_training/i.test(raw)) {
      return raw
        ? `Конфликт с занятием: ${raw}\nВыберите свободный интервал — слоты секций и персональных недоступны для аренды.`
        : 'Выбранное время пересекается с занятием секции. Выберите свободный интервал.';
    }
    return raw
      ? `Запрос отклонён: ${raw}\nПроверьте слоты, вид спорта и соответствие режиму работы площадки.`
      : 'Запрос отклонён. Проверьте выбранные интервалы и обязательные поля.';
  }

  if (status === 403) {
    return raw ? `Недостаточно прав: ${raw}` : 'Недостаточно прав для этой операции.';
  }

  if (status === 404) {
    return raw ? `Не найдено: ${raw}` : 'Ресурс не найден. Обновите страницу.';
  }

  if (status === 422) {
    return raw ? `Проверка данных не пройдена: ${raw}` : 'Проверьте введённые данные.';
  }

  if (status === 503 || status === 502) {
    return 'Сервис временно недоступен. Повторите попытку позже.';
  }

  if (/conflict|пересеч|занят|occupied|overlap|конфликт/i.test(raw)) {
    return `Конфликт расписания: ${raw}\nВыберите другое время или обновите расписание после устранения пересечения.`;
  }

  if (raw) return raw;
  return 'Не удалось выполнить операцию. Обновите страницу и попробуйте снова.';
}
